import { render, staticRenderFns } from "./GoodsTypeStatistics.vue?vue&type=template&id=6fc99446&scoped=true&"
import script from "./GoodsTypeStatistics.vue?vue&type=script&lang=js&"
export * from "./GoodsTypeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc99446",
  null
  
)

export default component.exports